export default __webpack_public_path__ + "static/media/Nosotros_imagen2_320.fc82692a.jpg";